<template>
  <div class="st-table">
    <el-row :gutter="12">
      <el-form class="form" ref="form" :model="form" :rules="rules" label-position="left" label-width="145px" label-colon>
        <el-col :span="10" >
          <el-card shadow="always">
            <el-row :gutter="16">
              <el-col :span="3">
                <el-form-item label="Project No">
                  <el-input
                    v-model="form.project_id"
                    style="width:250px"
                    :disabled="true"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="3">
                <el-form-item label="Product Name" prop="product_id">
                  <el-select v-model="form.product_id"
                             clearable
                             filterable
                             remote
                             style="width:260px"
                             :loading="isReqsFetching"
                             :remote-method="fetchProduct"
                             @change="onProductChange"
                  >
                    <el-option
                      v-for="item in options.productList"
                      :key="item.id"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="3">
                <el-form-item label="Alias Name">
                  <el-input
                    v-model="form.alias_name"
                    style="width:260px"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="3">
                <el-form-item label="Plan Version">
                  <el-input
                    v-model="form.plan_version"
                    style="width:260px"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="3">
                <el-form-item label="Actual Version">
                  <el-input
                    v-model="form.actual_version"
                    style="width:260px"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="3">
                <el-form-item label="Requirement">
                  <el-select v-model="form.req_ids"
                             clearable
                             multiple
                             style="width:260px"
                  >
                    <el-option
                      v-for="item in options.reqList"
                      :key="item.id"
                      :label="item.reqNo"
                      :value="item.reqNo">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="3">
                <el-form-item label="Due Date">
                  <el-date-picker
                    v-model="form.due_date"
                    type="date"
                    style="width:260px"
                    value-format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="3">
                <el-form-item label="Project Type" prop="project_type">
                  <el-select v-model="form.project_type"
                             clearable
                             style="width:260px">
                    <el-option
                      v-for="item in this.projectTypeList"
                      :key="item"
                      :label="item"
                      :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="3">
                <el-form-item label="Project Manager" prop="pm_id">
                  <el-select v-model="form.pm_id"
                             clearable
                             style="width:260px">
                    <el-option
                      v-for="item in options.pmList"
                      :key="item.id"
                      :label="item.label"
                      :value="item.value">
                    </el-option>

                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="3">
                <el-form-item label="Status" prop="status">
                  <el-select v-model="form.status"
                             clearable
                             style="width:260px">
                    <el-option
                      v-for="item in this.statusList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="3">
                <el-form-item label="Project Status" prop="d_status">
                  <el-select v-model="form.d_status"
                             clearable
                             style="width:260px">
                    <el-option
                      v-for="item in this.d_statusList"
                      :key="item.value"
                      :label="item.value"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="3">
                <el-form-item label="Links">
                  <el-input
                    v-model="form.links"
                    style="width:260px"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
        <el-col :span="14">
          <el-card shadow="always">
            <el-row :gutter="16">
              <el-col :span="3">
                <el-form-item label="Risk">
                  <el-select
                    style="width:260px"
                    v-model="form.risk"
                  >
                    <el-option
                      v-for="item in this.riskList"
                      :key="item.value"
                      :label="item.value"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="3">
                <el-form-item label="Plan Start Date" prop="plan_start">
                  <el-date-picker
                    v-model="form.plan_start"
                    type="date"
                    style="width:260px"
                    value-format="yyyy-MM-dd"
                    @change="changeStart"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="3">
                <el-form-item label="Plan End Date" prop="plan_end">
                  <el-date-picker
                    v-model="form.plan_end"
                    type="date"
                    @change="changeEnd"
                    style="width:260px"
                    value-format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="3">
                <el-form-item label="Plan Days">
                  <el-input
                    style="width:260px"
                    :disabled="true"
                    v-model="form.plan_days"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="3">
                <el-form-item label="Actual Start Date">
                  <el-date-picker
                    v-model="form.actual_start"
                    type="date"
                    style="width:260px"
                    value-format="yyyy-MM-dd"
                    @change="a_changeStart"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="3">
                <el-form-item label="Actual End Date">
                  <el-date-picker
                    v-model="form.actual_end"
                    type="date"
                    style="width:260px"
                    value-format="yyyy-MM-dd"
                    @change="a_changeEnd"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="3">
                <el-form-item label="Actual Days">
                  <el-input
                    style="width:260px"
                    v-model="form.actual_days"
                    :disabled="true"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="3">
                <el-form-item label="Adjust Days">
                  <el-input
                    style="width:260px"
                    v-model="form.adjust_days"
                    @change="final_days_change"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="3">
                <el-form-item label="Final Days">
                  <el-input
                    style="width:260px"
                    :disabled="true"
                    v-model="form.final_days"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col>
                <el-button type="primary" @click="submit('form')">
                  Submit
                </el-button>
              </el-col>
            </el-row>
            <!--            <div style="margin-top: 5px; text-align: left">-->

            <!--            </div>-->
          </el-card>
        </el-col>
      </el-form>
    </el-row>

  </div>
</template>

<script>

import reqApi from "@/api/req";
import userApi from "@/api/user";
import productApi from "@/api/product";
import projectApi from "@/api/project";

export default {
  name: "projectEdit",
  data() {
    return {
      projects: [],
      projectTypeList: ['New','Upgrade'],
      statusList:[
        {value:'To Do', label:'To Do'},
        {value:'In Progress', label:'In Progress'},
        {value:'Hold' , label:'Hold'},
        {value:'Complete' , label:'Complete'}
      ],
      d_statusList:[
        {value:'To Do', label: 'To Do'},
        {value:'Designing', label: 'Designing'},
        {value:'Developing', label: 'Developing'},
        {value:'Testing', label: 'Testing'},
        {value:'Debug/Bug fixing', label: 'Debug/Bug fixing'},
        {value:'Releasing', label: 'Releasing'},
        {value:'Archive', label: 'Archive'}
      ],
      riskList:[
        {value:'High', label:'High'},
        {value:'Low' , label:'Low'},
        {value:'Normal' , label:'Normal'},
        {value:'Unknown' , label:'Unknown'}
      ],
      detail:'',
      loading: false,
      isReqsFetching: false,
      form: {
        "project_id":'',
        "product_id":'',
        "project_name":'',
        "alias_name":'',
        "plan_version":'',
        "actual_version":'',
        "req_ids":'',
        "project_type":'',
        "due_date":'',
        "pm_id":'',
        "pm_name":'',
        "status":'',
        "d_status":'',
        "links":'',
        "risk":'',
        "attachment":'',
        "plan_start":'',
        "plan_end":'',
        "plan_days": '',
        "actual_start":'',
        "actual_end":'',
        "final_days":'',
        "adjust_days":'',
      },
      options: {
        pmList: [],
        productList: [],
        reqList:[]
      },
      rules:{
        product_id: [{
          required:true, message:'Please Input', trigger:'blur'
        }],
        project_type: [{
          required:true, message:'Please Input', trigger:'blur'
        }],
        pm_id: [{
          required:true, message:'Please Input', trigger:'blur'
        }],
        status: [
          {
            required:true, message:'Please Input', trigger:'blur'
          }
        ],
        d_status: [
          {
            required:true, message:'Please Input', trigger:'blur'
          }
        ],
        plan_start:[
          {
            required:true, message:'Please Input', trigger:'blur'
          }
        ],
        plan_end:[
          {
            required:true, message:'Please Input', trigger:'blur'
          }
        ],
      },
    }
  },

  methods:{
    changeStart(){
      if (this.form.plan_end !== undefined||this.form.plan_start !== undefined) {
        if (this.form.plan_end < this.form.plan_start) {
          this.$alert("Plan Start Date must be earlier than plan end Date！", { dangerouslyUseHTMLString: true });
          this.form.plan_start = undefined;
        }
        var ONE_DAY = 1000 * 60 * 60 * 24
        //console.log(this.form.plan_end)
        var date1_ms = new Date(this.form.plan_end).getTime()
        var date2_ms = new Date(this.form.plan_start).getTime()
        var difference_ms = Math.abs(date1_ms - date2_ms)
        this.form.plan_days =Math.round(difference_ms/ONE_DAY+1);
      }
    },
    changeEnd(){
      if (this.form.plan_end !== undefined||this.form.plan_start !== undefined) {
        if (this.form.plan_end < this.form.plan_start) {
          this.$alert("Plan Start Date must be earlier than plan end Date！", { dangerouslyUseHTMLString: true });
          this.form.plan_end = undefined;
        }
        var ONE_DAY = 1000 * 60 * 60 * 24
        //console.log(this.form.plan_end)
        var date1_ms = new Date(this.form.plan_end).getTime()
        var date2_ms = new Date(this.form.plan_start).getTime()
        var difference_ms = Math.abs(date1_ms - date2_ms)
        this.form.plan_days =Math.round(difference_ms/ONE_DAY+1);
      }
    },
    a_changeStart(){
      if (this.form.actual_end !== undefined||this.form.actual_start !== undefined) {
        if (this.form.actual_end < this.form.actual_start) {
          this.$alert("Actual Start Date must be earlier than actual end Date！", { dangerouslyUseHTMLString: true });
          this.form.actual_start = undefined;
        }

        var ONE_DAY = 1000 * 60 * 60 * 24
        //console.log(this.form.actual_end)
        var date1_ms = new Date(this.form.actual_end).getTime()
        var date2_ms = new Date(this.form.actual_start).getTime()
        var difference_ms = Math.abs(date1_ms - date2_ms)
        this.form.actual_days =Math.round(difference_ms/ONE_DAY+1);
      }
    },
    a_changeEnd(){
      if (this.form.actual_end !== undefined||this.form.actual_start !== undefined) {
        if (this.form.actual_end < this.form.actual_start) {
          this.$alert("Actual Start Date must be earlier than actual end Date！", { dangerouslyUseHTMLString: true });
          this.form.actual_end = undefined;
        }
        var ONE_DAY = 1000 * 60 * 60 * 24
        //console.log(this.form.actual_end)
        var date1_ms = new Date(this.form.actual_end).getTime()
        var date2_ms = new Date(this.form.actual_start).getTime()
        //console.log(date2_ms)
        var difference_ms = Math.abs(date1_ms - date2_ms)
        //console.log(difference_ms)
        this.form.actual_days =Math.round(difference_ms/ONE_DAY+1);
        //console.log(this.form.actual_end)
      }
    },
    final_days_change(){
      this.form.final_days = parseInt(this.form.actual_days) + parseInt(this.form.adjust_days)
    },
    getSelects() {
      userApi.getUsers().then(res=> {
        let users = res.data
        for (let user of users) {
          this.options.pmList.push({value: user.id, label: user['fullName']})
        }
      })
      productApi.getProducts().then(res=> {
          let products = res.data
          for (let product of products) {
            this.options.productList.push({value: product.id, label: product.name})
          }
        }
      )
    },
    onProductChange(val) {
      Object.assign(this.form, {
        req_id: undefined,
      })
      this.fetchReqs(val)
    },
    fetchProduct(query) {
      if (query !== '') {
        this.isReqsFetching = true
        productApi.getProducts(query.trim()).then(({data}) => {
          this.isReqsFetching = false
          this.options.productList = (data || []).map(item => {
            return {
              value: item.id,
              label: item.name,
              key: item.id,
            }
          })
        })
      } else {
        this.options.productList = []
      }
    },
    fetchReqs(product_id) {
      reqApi.getReqList(product_id).then(res => {
        this.options.reqList = res.data.data
      })
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true
          let payload = Object.assign({}, this.form)
          payload['product_id'] = this.form.product_id
          payload['alias_name'] = this.form.alias_name
          payload['plan_version'] = this.form.plan_version
          payload['actual_version'] = this.form.actual_version
          payload['req_ids'] = this.form.req_ids
          payload['due_date'] = this.form.due_date
          payload['pm_id'] = this.form.pm_id
          payload['project_type'] = this.form.project_type
          // payload['status'] = this.form.status
          payload['d_status'] = this.form.d_status
          payload['risk'] = this.form.risk
          payload['plan_version'] = this.form.plan_version
          payload['actual_version'] = this.form.actual_version
          payload['attachment'] = this.form.attachment
          const project_id = this.$route.query.id
          let para = { id:  project_id}
          projectApi.editProject(para, payload).then()
          this.loading = false
        } else {
          this.$message.error("Please filled with form")
        }
      })
    },
    getProjectDetail(project_id) {
      projectApi.getProjectDetail(project_id).then(res=>{
        this.projects = res.data.data
        this.project = this.projects[0]
        this.form.project_id = this.project['projectId']
        this.form.alias_name = this.project['aliasName']
        this.form.product_id = this.project['productId']
        this.form.plan_version = this.project['planVersion']
        this.form.actual_version = this.project['actualVersion']
        this.form.req_ids = JSON.parse(this.project['reqIds'])
        this.form.due_date = this.project['dueDate']
        this.form.project_type = this.project['projectType']
        this.form.pm_id = this.project['pmId']
        this.form.status = this.project['status']
        this.form.risk = this.project['risk']
        this.form.links = this.project['links']
        this.form.plan_start = this.project['planStart']
        this.form.plan_end = this.project['planEnd']
        this.form.plan_days = (Date.parse(this.project['planEnd']) - Date.parse(this.project['planStart']))/(24*60*60*1000)
        this.form.actual_start = this.project['actualStart']
        this.form.actual_end = this.project['actualEnd']
        this.form.adjust_days = this.project['adjustDays']
        this.form.d_status = this.project['dStatus']
      })
    }
  },
  watch: {
    projects(){
      this.$nextTick(() => {
        /*const projectId = this.$route.query.id
        this.getProjectDetail(projectId)*/
        this.fetchReqs(this.project['productId'])
      })
    }
  },
  created() {
    const projectId = this.$route.query.id
    if (projectId) {
      this.getProjectDetail(projectId)
    }
  },
  mounted(){
    this.getSelects()
  },

}
</script>

<style scoped>
</style>
